import { JwtInterceptor } from './auth/jwt.interceptor';
import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OverlayContainer } from '@angular/cdk/overlay';
import { CustomOverlayContainer } from './theme/utils/custom-overlay-container';
import { PerfectScrollbarModule } from '@harvest-dev/ng-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from '@harvest-dev/ng-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from '@harvest-dev/ng-perfect-scrollbar';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  wheelPropagation: true,
  suppressScrollX: true
};
import { SharedModule } from './shared/shared.module';
import { PipesModule } from './theme/pipes/pipes.module';
import { AppRoutingModule } from './app.routing';
import { AppSettings } from './app.settings';
import { AppComponent } from './app.component';
import { BlankComponent } from './shared-component/blank/blank.component';
import { NotFoundComponent } from './shared-component/errors/not-found/not-found.component';
import { ErrorComponent } from './shared-component/errors/error/error.component';
import { TopInfoContentComponent } from './theme/components/top-info-content/top-info-content.component';
import { SidenavComponent } from './theme/components/sidenav/sidenav.component';
import { VerticalMenuComponent } from './theme/components/menu/vertical-menu/vertical-menu.component';
import { HorizontalMenuComponent } from './theme/components/menu/horizontal-menu/horizontal-menu.component';
import { FlagsMenuComponent } from './theme/components/flags-menu/flags-menu.component';
import { FullScreenComponent } from './theme/components/fullscreen/fullscreen.component';
import { ApplicationsComponent } from './theme/components/applications/applications.component';
import { MessagesComponent } from './theme/components/messages/messages.component';
import { UserMenuComponent } from './theme/components/user-menu/user-menu.component';
import { FavoritesComponent } from './theme/components/favorites/favorites.component';
import { PageTitleComponent } from './theme/components/page-title/page-title.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthLayoutComponent } from './shared-component/auth-layout/auth-layout.component';
import { PublicLayoutComponent } from './shared-component/public-layout/public-layout.component';
import { UserSettingsComponent } from './shared-component/user-settings/user-settings.component';
import { ErrorDialogComponent } from './shared-component/ui-shared/error-dialog/error-dialog.component';
import { SuccessDialogComponent } from './shared-component/ui-shared/success-dialog/success-dialog.component';
import { ConfirmDialogComponent } from './shared-component/ui-shared/confirm-dialog/confirm-dialog.component';
import { GlobalHttpErrorInterceptorService } from './shared/interceptor/GlobalHttpErrorInterceptorService';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatBadgeModule } from '@angular/material/badge';
//import { HelpAgentComponent } from './shared-component/help-agent/help-agent.component';
import { SafeHtmlPipe } from './theme/pipes/safeHtml/safeHtml.pipe';

@NgModule({ declarations: [
        AppComponent,
        BlankComponent,
        NotFoundComponent,
        ErrorComponent,
        TopInfoContentComponent,
        SidenavComponent,
        HorizontalMenuComponent,
        FlagsMenuComponent,
        FullScreenComponent,
        ApplicationsComponent,
        MessagesComponent,
        UserMenuComponent,
        FavoritesComponent,
        PageTitleComponent,
        AuthLayoutComponent,
        PublicLayoutComponent,
        UserSettingsComponent,
        ErrorDialogComponent,
        SuccessDialogComponent,
        //HelpAgentComponent
    ],
    bootstrap: [
        AppComponent
    ],
    exports: [
        TranslateModule,
        SafeHtmlPipe
    ], imports: [BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        MatBadgeModule,
        VerticalMenuComponent,
        PerfectScrollbarModule,
        SharedModule,
        PipesModule,
        TranslateModule.forRoot({
            loader: provideTranslateHttpLoader()
        }),
        AppRoutingModule], providers: [
        AppSettings,
        //{ provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
        { provide: OverlayContainer, useClass: CustomOverlayContainer },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: GlobalHttpErrorInterceptorService, multi: true },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
